import React, { useEffect, useState, useMemo } from "react";
import useStore from "../../../useStore";
import "./ordenes.css";
import Loader from "../../Elements/Loader/Loader";
import { Link } from "react-router-dom";
import SearchInput from "../../Elements/Search/Search";
import { formatDate, formatNumber } from "../../Helpers/helpers";

const Ordenes = () => {
  const {
    fetchOrdenesResumen,
    ordenesResumen = [],
    loading,
    error,
  } = useStore();

  const [busqueda, setBusqueda] = useState("");

  // Normaliza cadenas: minúsculas, sin tildes, sin espacios extras
  const normalize = (str = "") =>
    str
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();

  useEffect(() => {
    fetchOrdenesResumen();
  }, [fetchOrdenesResumen]);

  const ordenesFiltradas = useMemo(() => {
    const txt = normalize(busqueda);
    return ordenesResumen.filter((orden) => {
      return [
        orden.orden,
        formatDate(orden.fecha_pedido),
        formatDate(orden.fecha_entrega),
        orden.cliente,
        orden.referencia_cliente,
        orden.producto,
        orden.descripcion,
      ].some((campo) => normalize(String(campo)).includes(txt));
    });
  }, [busqueda, ordenesResumen]);

  return (
    <div className="ordenes-wrapper container-mh">
      <h2 className="ordenes-title">Resumen de Órdenes</h2>

      {/* Buscador */}
      <div className="ordenes-filters row mb-3 g-2 align-items-end">
        <div className="col-12">
          <SearchInput
            value={busqueda}
            onChange={setBusqueda}
            onClear={() => setBusqueda("")}
            placeholder="Buscar por orden, cliente, producto, etc."
            typeLabel="Buscar"
            name="ordenes-busqueda"
            showClear
          />
        </div>
      </div>

      {loading && <Loader />}

      {!loading && error && (
        <div className="alert alert-danger">
          Ocurrió un error al obtener las órdenes: {error}
        </div>
      )}

      {!loading && !error && ordenesFiltradas.length > 0 && (
        <div className="ordenes-table-container">
          <table className="ordenes-table">
            <thead>
              <tr>
                <th>Orden</th>
                <th>Fecha Pedido</th>
                <th>Fecha Entrega</th>
                <th>Cliente</th>
                <th>Ref. Cliente</th>
                <th>Producto / Descripción</th>
                <th>Cantidad</th>
                <th>Estatus</th>
              </tr>
            </thead>
            <tbody>
              {ordenesFiltradas.map((orden) => (
                <tr key={orden.orden}>
                  <td data-label="Orden">
                    <Link to={`/ordenes/${orden.orden}`} className="orden-link">
                      {orden.orden}
                    </Link>
                  </td>
                  <td data-label="Fecha Pedido">
                    {formatDate(orden.fecha_pedido)}
                  </td>
                  <td data-label="Fecha Entrega">
                    {formatDate(orden.fecha_entrega)}
                  </td>
                  <td data-label="Cliente">{orden.cliente}</td>
                  <td data-label="Ref. Cliente">{orden.referencia_cliente}</td>
                  <td data-label="Producto / Descripción">
                    <strong>{orden.producto}</strong>
                    <br />
                    <small>{orden.descripcion}</small>
                  </td>
                  <td data-label="Cantidad">
                    {formatNumber(orden.cantidad_solicitada)}
                  </td>
                  <td data-label="Estatus">
                    <span className={`status-badge ${normalize(orden.estatus).replace(/\s+/g, "-")}`}>
                      {orden.estatus}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="scroll-shadow top" />
          <div className="scroll-shadow bottom" />
        </div>
      )}

      {!loading && !error && ordenesFiltradas.length === 0 && (
        <p className="text-muted text-center mt-4">
          No se encontraron resultados con los filtros actuales.
        </p>
      )}
    </div>
  );
};

export default Ordenes;
